import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const mediaMatch = window.matchMedia("(min-width: 990px)");
  const [matches, setMatches] = useState(mediaMatch.matches);
  const [isHovered, setHovered] = useState(false);

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  }, []);

  return (
    <div>
      <section className="page_topline cs logo-color table_section table_section_sm section_padding_top_5 section_padding_bottom_5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-8 text-center text-sm-left hide-it">
              <div className="padding-left--75">
                {/* <i className="fa fa-clock-o rightpadding_5" aria-hidden="true"></i> */}
                Caring Heart . Digital Mind
              </div>
            </div>
            <div className="col-sm-4 text-center text-sm-right greylinks padding-right--75 padding-left--0">
              {" "}
              <span className="rightpadding_10">Follow Us:</span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="soc-icon color-icon soc-facebook"
                href="https://www.facebook.com/Carin.Lifesciences/"
                title="Facebook"
              >
                fb
              </a>
              {/* <a target="_blank" rel="noopener noreferrer" className="soc-icon color-icon soc-twitter" href="#" title="Twitter"></a> */}
              {/* <a target="_blank" rel="noopener noreferrer" className="soc-icon color-icon soc-google" href="#" title="Google"></a> */}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="soc-icon color-icon soc-instagram"
                href="https://www.instagram.com/livecarin/"
                title="Instagram"
              >
                instagram
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="soc-icon color-icon soc-linkedin"
                href="https://www.linkedin.com/company/carinlife"
                title="Linkedin"
              >
                linkedin
              </a>
              {/* <a target="_blank" rel="noopener noreferrer" className="soc-icon color-icon soc-youtube" href="#" title="Youtube"></a> */}
            </div>
          </div>
        </div>
      </section>
      <header className="page_header header_white toggler_xs_right section_padding_25">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 display_table">
              <div className="header_left_logo display_table_cell">
                {" "}
                <a className="logo top_logo" href="/">
                  <img
                    className="carin_logo"
                    src={process.env.REACT_APP_IMAGES + "/carin.svg"}
                    alt=""
                  />
                </a>
              </div>
              <div className="header_mainmenu display_table_cell text-center">
                <nav className="mainmenu_wrapper">
                  <ul className="mainmenu nav sf-menu">
                    <li className={splitLocation[1] === "" ? "active" : ""}>
                      {" "}
                      <a href="/">Home</a>
                    </li>
                    <li
                      className={splitLocation[1] === "about" ? "active" : ""}
                    >
                      {" "}
                      {matches ? (
                        <Link to="/about">About Us</Link>
                      ) : (
                        <a href="/about">About Us</a>
                      )}
                    </li>
                    <li
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      className={
                        splitLocation[1] === "offerings"
                          ? isHovered
                            ? "active sfHover"
                            : "active"
                          : isHovered
                          ? "sfHover"
                          : ""
                      }
                    >
                      {" "}
                      {matches ? (
                        <Link className="sf-with-ul" to="/offerings">
                          Our Offerings
                        </Link>
                      ) : (
                        <a href="/offerings">Our Offerings</a>
                      )}
                      <ul
                        style={
                          isHovered
                            ? { display: "block", marginTop: 0 }
                            : { display: "none", marginTop: "5px" }
                        }
                      >
                        <li>
                          {" "}
                          <a href="/offerings/gynaecology">Gynaecology</a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/cardiovascular_metabolics">
                            Cardiovascular Metabolics
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/anti-diabetics">
                            Anti-Diabetics
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/respiratory">Respiratory</a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/dermatology">Dermatology</a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/analgesics">
                            Pain/Analgesics
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/anti-infectives">
                            Anti-infectives
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/gastrology">Gastrology</a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href="/offerings/vitamins">Vitamins</a>{" "}
                        </li>
                      </ul>
                    </li>
                    <li
                      className={
                        splitLocation[1] === "community" ? "active" : ""
                      }
                    >
                      {" "}
                      {matches ? (
                        <Link to="/community">Our Community</Link>
                      ) : (
                        <a href="/community">Our Community</a>
                      )}
                    </li>
                    <li
                      className={splitLocation[1] === "blogs" ? "active" : ""}
                    >
                      {" "}
                      {matches ? (
                        <Link to="/blogs">Our Blogs</Link>
                      ) : (
                        <a href="/blogs">Our Blogs</a>
                      )}{" "}
                    </li>
                    <li
                      className={splitLocation[1] === "careers" ? "active" : ""}
                    >
                      {" "}
                      {matches ? (
                        <Link to="/careers">Careers</Link>
                      ) : (
                        <a href="/careers">Careers</a>
                      )}
                    </li>
                    <li
                      className={splitLocation[1] === "contact" ? "active" : ""}
                    >
                      <a href="/contact">Contact</a>
                    </li>
                  </ul>
                </nav>
                <span className="toggle_menu">
                  <span></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
